import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Lang } from '@appCore/models';
import { HistoryService } from '@appCore/services/history.service';
import { IconsService } from '@appCore/services/icons.service';
import { RolesService } from '@appCore/services/roles.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(translateService: TranslateService, iconsService: IconsService, historyService: HistoryService, rolesService: RolesService) {
        iconsService.loadIcons();
        translateService.addLangs([Lang.Spanish]);
        translateService.setDefaultLang(Lang.Spanish);
        translateService.use(Lang.Spanish);
        historyService.startSaveHistory();
        rolesService.listenRoutes();
    }
}
